import React from "react";
import { Button, Icon } from "semantic-ui-react";
import moment from "moment";
const UploadCampaignFile = ({ importCSV, campaign, getCampaignExport }) => (
	<div>
		<Button
			onClick={() => {
				importCSV();
			}}
			icon
			labelPosition="left"
		>
			{" "}
			<Icon name="download" />
			Ajouter des patients à la campagne via un fichier csv
		</Button>
		<Button
			onClick={() => {
				getCampaignExport(campaign.id).then((res) => {
					const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.payload.data.base64}`;
					const downloadLink = document.createElement("a");
					const fileName = `campaign_${campaign.name}_${moment().format("YYYYMMDD_HHmm")}.xlsx`;
					downloadLink.href = linkSource;
					downloadLink.download = fileName;
					downloadLink.click();
				});
			}}
			icon
			labelPosition="left"
		>
			{" "}
			<Icon name="upload" />
			Exporter les résultats de la campagne
		</Button>
	</div>
);

export default UploadCampaignFile;
